import { create, tsx } from '@dojo/framework/core/vdom';
import ContentWrapper from '../../widgets/ContentWrapper';
import { Text } from '../../widgets/Text';
import Page from '../../widgets/Page';
import HeroBackground, { BackgroundKey } from '../../widgets/HeroBackground';
import { RenderResult } from '@dojo/framework/core/interfaces';

import * as css from './OpenSourcePage.m.css';
import Summary from '../../widgets/Summary';
import OSSLinks from '../../widgets/OSSLinks';
import Section from '../../widgets/Section';
import ConnectStrip from '../../widgets/ConnectStrip';

interface OpenSourcePageChildren {
	head?: RenderResult;
	hero: {
		title: RenderResult;
		xlTitle: RenderResult;
	};
	page: RenderResult;
}

interface OpenSourcePageProperties {
	background: BackgroundKey;
	ossLinks?: boolean;
	heroAlign?: 'center';
	pageSize?: 'smaller' | 'medium';
}

const factory = create().properties<OpenSourcePageProperties>().children<OpenSourcePageChildren>();

export const OpenSourcePage = factory(function OpenSourcePage({ children, properties }) {
	const [
		{
			hero: { title, xlTitle },
			head,
			page
		}
	] = children();
	const { background, ossLinks = true, heroAlign, pageSize = 'medium' } = properties();
	return (
		<Page>
			{{
				head,
				hero: {
					background: <HeroBackground background={background} />,
					content: (
						<ContentWrapper>
							<div classes={[css.hero]}>
								<Text type="hero-subhead" align={heroAlign}>
									{title}
								</Text>
								<div align={heroAlign}>
									<Text type="hero-primary" responsive="callout-head">
										{xlTitle}
									</Text>
								</div>
							</div>
						</ContentWrapper>
					)
				},
				page: (
					<virtual>
						<Section type="leading">
							<ContentWrapper size={pageSize}>{page}</ContentWrapper>
						</Section>
						{ossLinks && (
							<Section type="leading">
								<ContentWrapper>
									<Summary stack>
										{{
											blurb: <OSSLinks />
										}}
									</Summary>
								</ContentWrapper>
							</Section>
						)}
						<Section type="trailing" shaded>
							<ConnectStrip trailing />
						</Section>
					</virtual>
				)
			}}
		</Page>
	);
});

export default OpenSourcePage;
